module.exports = __webpack_public_path__ + "img/ios-app-store-qr-code.36721e63.png";